// src/App.js
import React, { useState, useEffect } from 'react'; 
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import DashboardLayout from './layouts/DashboardLayout';
import ReferralsPage from './pages/ReferralsPage';
import UsersPage from './pages/UsersPage'; // <--- 1. IMPORT THIS

// A simple component to protect routes
const PrivateRoute = ({ children }) => {
  const isAdminLoggedIn = !!localStorage.getItem('admin_token');
  return isAdminLoggedIn ? children : <Navigate to="/login" />;
};

// --- CSS for the loader ---
const LoaderStyles = () => (
  <style>{`
    /* From Uiverse.io by dovatgabriel */
    .three-body {
      --uib-size: 35px;
      --uib-speed: 0.8s;
      --uib-color: #667eea; 
      position: relative;
      display: inline-block;
      height: var(--uib-size);
      width: var(--uib-size);
      animation: spin78236 calc(var(--uib-speed) * 2.5) infinite linear;
    }
    .three-body__dot {
      position: absolute;
      height: 100%;
      width: 30%;
    }
    .three-body__dot:after {
      content: '';
      position: absolute;
      height: 0%;
      width: 100%;
      padding-bottom: 100%;
      background-color: var(--uib-color);
      border-radius: 50%;
    }
    .three-body__dot:nth-child(1) {
      bottom: 5%;
      left: 0;
      transform: rotate(60deg);
      transform-origin: 50% 85%;
    }
    .three-body__dot:nth-child(1)::after {
      bottom: 0;
      left: 0;
      animation: wobble1 var(--uib-speed) infinite ease-in-out;
      animation-delay: calc(var(--uib-speed) * -0.3);
    }
    .three-body__dot:nth-child(2) {
      bottom: 5%;
      right: 0;
      transform: rotate(-60deg);
      transform-origin: 50% 85%;
    }
    .three-body__dot:nth-child(2)::after {
      bottom: 0;
      left: 0;
      animation: wobble1 var(--uib-speed) infinite
        calc(var(--uib-speed) * -0.15) ease-in-out;
    }
    .three-body__dot:nth-child(3) {
      bottom: -5%;
      left: 0;
      transform: translateX(116.666%);
    }
    .three-body__dot:nth-child(3)::after {
      top: 0;
      left: 0;
      animation: wobble2 var(--uib-speed) infinite ease-in-out;
    }
    @keyframes spin78236 { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
    @keyframes wobble1 { 0%, 100% { transform: translateY(0%) scale(1); opacity: 1; } 50% { transform: translateY(-66%) scale(0.65); opacity: 0.8; } }
    @keyframes wobble2 { 0%, 100% { transform: translateY(0%) scale(1); opacity: 1; } 50% { transform: translateY(66%) scale(0.65); opacity: 0.8; } }
  `}</style>
);

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const validateToken = async () => {
      const token = localStorage.getItem('admin_token');
      if (!token) {
        setLoading(false); 
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/users`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (!response.ok) {
          throw new Error('Invalid token');
        }
        
        const role = localStorage.getItem('admin_role');
        if (!role) {
            console.warn("Token valid, but no role found. Logging out.");
            throw new Error("Role not found");
        }
        
        setLoading(false);

      } catch (error) {
        console.error('Admin token validation failed:', error.message);
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_role');
        setLoading(false); 
      }
    };

    validateToken();
  }, []); 

  if (loading) {
    return (
      <>
        <LoaderStyles />
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh', 
          backgroundColor: '#F9FAFB', 
          fontFamily: 'Inter, sans-serif'
        }}>
          <div className="three-body">
            <div className="three-body__dot"></div>
            <div className="three-body__dot"></div>
            <div className="three-body__dot"></div>
          </div>
          <h2 style={{ 
            marginTop: '20px', 
            color: '#4B5563',
            fontWeight: '500',
            fontSize: '1.25rem'
          }}>
            Loading Admin Session...
          </h2>
        </div>
      </>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        
        {/* Protected Routes wrapped by the DashboardLayout */}
        <Route 
          path="/" 
          element={
            <PrivateRoute>
              <DashboardLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="referrals" element={<ReferralsPage />} />
          <Route path="users" element={<UsersPage />} /> {/* <--- 2. ADDED THIS ROUTE */}
        </Route>

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;